module.exports = __webpack_public_path__ + "img/rankOne.55bc96cc.png";